import {
    Icon,
    IconButton
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { CommonTable } from '../../_components/table/common.table';
import { PaperTableHeader } from '../../_components/table/header.table';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { SearchTableHeader } from '../../_components/table/search.table';
import { ticketActionListService } from '../../_services/ticketActionList.service';
import { TicketPurgeLogManageDrawer } from './ticketPurgeLog-manage';
import { ticketPurgeLogService } from '../../_services/ticketPurgeLog.service';
import { getDate } from '../../_helpers/dateTime.helper';

export function TicketPurgeLogIndex() {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState({ ...TABLE_FILTER });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await ticketPurgeLogService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            //{
            //    id: 'actions',
            //    header: 'Actions',
            //    size: 80,
            //    enableSorting: false,
            //    enableColumnFilter: false,
            //    Cell: ({ row }) => (
            //        <IconButton
            //            color="primary"
            //            onClick={() => { navigate("Manage/" + row.original.id) }}>
            //            <Icon>edit</Icon>
            //        </IconButton>
            //    ),
            //},
            {
                accessorKey: 'id',
                header: 'ID',
            },
            {
                accessorKey: 'startDate',
                header: 'Ticket Purge Start Date',
                accessorFn: (rowData: any) => <>{rowData.startDate != null ? getDate(rowData.startDate) : null}</>,
            },
            {
                accessorKey: 'endDate',
                header: 'Ticket Purge End Date',
                accessorFn: (rowData: any) => <>{rowData.endDate != null ? getDate(rowData.endDate) : null}</>,
            },
            {
                accessorKey: 'numberOfTicketsPurged',
                header: 'Number Of Tickets Purged',
            },
            {
                accessorKey: 'created',
                header: 'Created',
            },
        ],
        []
    );

    return (
        <>
            <PaperTableHeader title="Ticket Actions Log" buttons={[
                { icon: "add", label: "Create", onClick: () => { navigate("Create") } }
            ]} />

            <SearchTableHeader inputs={[
                { label: "Start Date", name: "startDate", type: "date", onChange: setFilter, value: filter.startDate },
                { label: "End Date", name: "endDate", type: "date", onChange: setFilter, value: filter.endDate }
            ]} />

            <CommonTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

            <Routes>
                <Route path="Create" element={< TicketPurgeLogManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="Manage/:id" element={< TicketPurgeLogManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
}
